module.exports = __webpack_public_path__ + "media/images/icons/office-building-with-bg-6cc8c415a6e782ed5eb94205a541ec35.svg";